(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.helpers = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  };
  var getParams = function getParams(url) {
    // get query string from url (optional) or window
    var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var params = {};

    // if query string exists
    if (queryString) {
      // remove # is not part of query string if present
      queryString = queryString.split("#")[0];
      // split our query string into its component parts
      var arr = queryString.split("&");
      for (var i = 0; i < arr.length; i++) {
        // separate the keys and the values
        var a = arr[i].split("=");

        // in case params are an array. e.g. gender[]=M&gender[]=F
        var paramNum = undefined;
        var paramName = a[0].replace(/\[\d*\]/, function (v) {
          paramNum = v.slice(1, -1);
          return "";
        });

        // set parameter value (use 'true' if empty)
        var paramValue = typeof a[1] === "undefined" ? true : a[1];

        // if parameter name already exists
        if (params[paramName]) {
          // convert value to array (if still string)
          if (typeof params[paramName] === "string") {
            params[paramName] = [params[paramName]];
          }
          // if no array index number specified...
          if (typeof paramNum === "undefined") {
            // put the value on the end of the array
            params[paramName].push(paramValue);
          } else {
            // if array index number specified...
            // put the value at that index number
            params[paramName][paramNum] = paramValue;
          }
        } else {
          // if param name doesn't exist yet, set it
          params[paramName] = paramValue;
        }
      }
    }
    //return the params object
    // console.log("params: ", params);
    return params;
  };
  //geocode translation
  //[countrycode(s), countryName/region name, Region associated to, region(bool)]
  //these countries are using non standard codes Zambia - ZAM, Zimbabwe - ZIM, Sierra Leone - SIE, Cambodia - CAM, Romania - ROM

  var geocodes = {
    "0027": ["BDI,ETH,KEN,RWA,TZA,UGA,LSO,MOZ,MWI,SWZ,ZAF,ZAM,ZAR,ZIM,GHA,MLI,NER,SEN,SIE,TCD", "Africa", "Africa", true],
    "0037": ["BDI,ETH,KEN,RWA,TZA,UGA", "East Africa", "East Africa", true],
    "0041": ["BDI", "Burundi", "East Africa", false],
    "0049": ["ETH", "Ethiopia", "East Africa", false],
    "0051": ["KEN", "Kenya", "East Africa", false],
    "0053": ["RWA", "Rwanda", "East Africa", false],
    "0059": ["TZA", "Tanzania", "East Africa", false],
    "0061": ["UGA", "Uganda", "East Africa", false],
    "0063": ["LSO,MOZ,MWI,SWZ,ZAF,ZAM,ZAR,ZIM", "Southern Africa", "Southern Africa", true],
    "0093": ["ZAR", "Congo, DRC", "Southern Africa", false],
    "0077": ["LSO", "Lesotho", "Southern Africa", false],
    "0081": ["MOZ", "Mozambique", "Southern Africa", false],
    "0083": ["MWI", "Malawi", "Southern Africa", false],
    "0087": ["SWZ", "Eswatini", "Southern Africa", false],
    "0089": ["ZAF", "South Africa", "Southern Africa", false],
    "0091": ["ZAM", "Zambia", "Southern Africa", false],
    "0095": ["ZIM", "Zimbabwe", "Southern Africa", false],
    "0097": ["GHA,MLI,NER,SEN,SIE,TCD", "West Africa", "West Africa", true],
    "0135": ["TCD", "Chad", "West Africa", false],
    "0111": ["GHA", "Ghana", "West Africa", false],
    "0123": ["MLI", "Mali", "West Africa", false],
    "0127": ["NER", "Niger", "West Africa", false],
    "0131": ["SEN", "Senegal", "West Africa", false],
    "0133": ["SIE", "Sierra Leone", "West Africa", false],
    "0143": ["BOL,COL,DOM,ECU,GTM,HND,HTI,NIC,PER,SLV", "Latin America/Caribbean", "Latin America/Caribbean", true],
    "0149": ["BOL", "Bolivia", "Latin America/Caribbean", false],
    "0155": ["COL", "Colombia", "Latin America/Caribbean", false],
    "0159": ["DOM", "Dominican Republic", "Latin America/Caribbean", false],
    "0161": ["ECU", "Ecuador", "Latin America/Caribbean", false],
    "0183": ["SLV", "El Salvador", "Latin America/Caribbean", false],
    "0163": ["GTM", "Guatemala", "Latin America/Caribbean", false],
    "0169": ["HTI", "Haiti", "Latin America/Caribbean", false],
    "0167": ["HND", "Honduras", "Latin America/Caribbean", false],
    "0175": ["NIC", "Nicaragua", "Latin America/Caribbean", false],
    "0179": ["PER", "Peru", "Latin America/Caribbean", false],
    "0191": ["BGD,CAM,IND,IDN,PHL,LKA,VNM", "Asia", "Asia", true],
    "0201": ["BGD", "Bangladesh", "Asia", false],
    "0203": ["CAM", "Cambodia (CAM)", "Asia", false],
    "0213": ["IND", "India", "Asia", false],
    "0211": ["IDN", "Indonesia", "Asia", false],
    "0233": ["PHL", "Philippines", "Asia", false],
    "0223": ["LKA", "Sri Lanka", "Asia", false],
    "0253": ["VNM", "Viet Nam", "Asia", false],
    "0299": ["ALB,ARM,KOS", "Eastern Europe", "Eastern Europe", true],
    "0303": ["ALB", "Albania", "Eastern Europe", false],
    "0305": ["ARM", "Armenia", "Eastern Europe", false],
    "0336": ["KOS", "Kosovo", "Eastern Europe", false]
  };

  var geoLocations = function geoLocations() {
    return geocodes;
  };
  // Sanitize incoming params for requests

  var searchParams = {
    gender: "gender",
    minimumAge: "minimumAge",
    maximumAge: "maximumAge",
    minimumBirthMonth: "minimumBirthMonth",
    maximumBirthMonth: "maximumBirthMonth",
    minimumBirthDayOfMonth: "minimumBirthDayOfMonth",
    maximumBirthDayOfMonth: "maximumBirthDayOfMonth",
    disabledFlag: "disabledFlag",
    orphan: "orphan",
    hasCGV: "hasCGV",
    countryCodes: "countryCodes",
    languageCode: "languageCode",
    favoriteGame: "favoriteGame",
    minimumDaysAwaitingSponsorshipCount: "minimumDaysAwaitingSponsorshipCount",
    projectIdentifiers: "projectIdentifiers",
    excludedChildIdentifiers: "excludedChildIdentifiers",
    supportOffice: "supportOffice",
    availableFlag: "availableFlag",
    status: "status",
    unavailableReasonCode: "unavailableReasonCode",
    webPublishableFlag: "webPublishableFlag",
    christianWitnessSensitivity: "christianWitnessSensitivity",
    reservationIdentifier: "reservationIdentifier",
    reservationReferenceIdentifier: "reservationReferenceIdentifier",
    identifier: "indentifier",
    reservePool: "reservePool",
    sortOrder: "sortOrder",
    take: "take",
    region: "region"

  };

  //convert legacy terms to RCDS terms or modify new terms
  var searchParamsMachine = {
    CG: { searchTerm: searchParams.gender, makeArray: false },
    xxwvGender: { searchTerm: searchParams.gender, makeArray: false },
    CA: { searchTerm: [searchParams.minimumAge, searchParams.maximumAge], makeArray: false },
    xxwvAge: { searchTerm: [searchParams.minimumAge, searchParams.maximumAge], makeArray: false },
    age: { searchTerm: [searchParams.minimumAge, searchParams.maximumAge], makeArray: false },
    hi_age: { searchTerm: searchParams.maximumAge, makeArray: false },
    lo_age: { searchTerm: searchParams.minimumAge, makeArray: false },
    CBM: { searchTerm: [searchParams.minimumBirthMonth, searchParams.maximumBirthMonth], makeArray: false },
    xxwvMonth: { searchTerm: [searchParams.minimumBirthMonth, searchParams.maximumBirthMonth], makeArray: false },
    hi_mo: { searchTerm: searchParams.maximumBirthMonth, makeArray: false },
    lo_mo: { searchTerm: searchParams.minimumBirthMonth, makeArray: false },
    CBD: { searchTerm: [searchParams.minimumBirthDayOfMonth, searchParams.maximumBirthDayOfMonth], makeArray: false },
    xxwvDay: { searchTerm: [searchParams.minimumBirthDayOfMonth, searchParams.maximumBirthDayOfMonth], makeArray: false },
    hi_day: { searchTerm: searchParams.maximumBirthDayOfMonth, makeArray: false },
    lo_day: { searchTerm: searchParams.minimumBirthDayOfMonth, makeArray: false },
    xxwvProject: { searchTerm: [searchParams.projectIdentifiers], makeArray: true },
    CP: { searchTerm: searchParams.projectIdentifiers, makeArray: true },
    projectIdentifiers: { searchTerm: searchParams.projectIdentifiers, makeArray: true },
    proj_list: { searchTerm: searchParams.projectIdentifiers, makeArray: true },
    xxwvLocation: { searchTerm: searchParams.countryCodes, makeArray: false },
    CL: { searchTerm: searchParams.countryCodes, makeArray: false },
    geo_num: { searchTerm: searchParams.countryCodes, makeArray: false },
    item: { searchTerm: searchParams.identifier, makeArray: false },
    childid: { searchTerm: searchParams.identifier, makeArray: false },
    xxwvChildId: { searchTerm: searchParams.identifier, makeArray: false },
    rsrv_camp_list: { searchTerm: searchParams.reservationReferenceIdentifier, makeArray: false },
    xxwvCampaign: { searchTerm: searchParams.reservationReferenceIdentifier, makeArray: false },
    resPool: { searchTerm: searchParams.reservationReferenceIdentifier, makeArray: false }
  };
  var conditionalTranslator = function conditionalTranslator(searchTerm, action, code) {
    // console.log("conditionalTranslator: ", code, code instanceof Array);
    //if country code params exist, translate them to ISO 3166-1 alpha-3 codes
    if (searchTerm == "CL" || searchTerm == "xxwvLocation" || searchTerm == "geo_num" || searchTerm == "region") {
      //handle country codes if there is only one
      if (!(code instanceof Array)) {
        //check to see if we know the legacy country code being used
        if (geocodes.hasOwnProperty(code)) {
          var convertedCoCode = geocodes[code];
          // console.log("converted Country Code: ",convertedCoCode[0])
          //if comma seperated list
          if (convertedCoCode[0].indexOf(',') > -1) {
            var paramsArray = convertedCoCode[0].split(',');
            // console.log("code:", paramsArray);
            return paramsArray;
          } else {
            return [convertedCoCode[0]];
          }
        }
      }
      //handle country codes if there is an array
      if (code instanceof Array) {
        var convertedCoCodeArray = [];
        // console.log("converted code: ", convertedCoCode);
        for (var i = 0; i < code.length; i++) {
          if (geocodes.hasOwnProperty(code[i])) {
            var _convertedCoCode = geocodes[code[i]];
            // console.log("converted code: ", convertedCoCode[0]);
            convertedCoCodeArray.push(_convertedCoCode[0]);
          }
        }
        // console.log("converted array code: ", convertedCoCodeArray)
        return convertedCoCodeArray;
      }
    } else {
      return code;
    }
  };
  var sanitizeParams = function sanitizeParams(params, action) {
    var sanitizedParams = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        //console.log(`sanatized params: ${key}, sanitzed action: ${action}, machine keys: ${Object.keys(searchParamsMachine)}`);
        //if seachterm exits in machine, then use it.  Otherwise just pass it along.
        if (searchParamsMachine.hasOwnProperty(key)) {
          //if search terms has an array.  Used to combine min and max in legacy params
          if (searchParamsMachine[key][action] instanceof Array) {
            for (var i = 0; i < searchParamsMachine[key][action].length; i++) {
              // console.log("is array: ", key);
              sanitizedParams[searchParamsMachine[key][action][i]] = params[key];
            }
          } else {
            if (searchParamsMachine[key].makeArray === true) {
              //check to see if it already is an array
              if (params[key] instanceof Array) {
                sanitizedParams[searchParamsMachine[key][action]] = params[key];
                // console.log("got here1:", sanitizedParams[searchParamsMachine[key][action]]);
              } else {
                sanitizedParams[searchParamsMachine[key][action]] = [params[key]];
                // console.log("got here2:", sanitizedParams[searchParamsMachine[key][action]]);
              }
              if (params[key].indexOf(',') > -1) {
                sanitizedParams[searchParamsMachine[key][action]] = params[key].split(',');
              }
            } else {
              sanitizedParams[searchParamsMachine[key][action]] = conditionalTranslator(key, action, params[key]);
            }
          }
        } else if (searchParams[key]) {
          //if key exists in searchParams
          // console.log("searchParams[key]: ",searchParams[key])
          if (searchParams[key] === "countryCodes" || searchParams[key] === 'region' && !(params[key] instanceof Array)) {
            if (searchParams[key] === 'region') {
              sanitizedParams["countryCodes"] = conditionalTranslator(searchParams[key], action, params[key]);
              console.log("sanitized params: ", sanitizedParams);
            }
            //if comma separated splice at comma
            else if (searchParams[key] !== "region" && params[key] != null && params[key].indexOf(',') > -1) {
                var paramsArray = params[key].split(',');
                // console.log("code:", paramsArray);
                sanitizedParams[key] = paramsArray;
              } else {
                //just return the string
                if (params[key] == null) {
                  sanitizedParams[key] = [];
                } else if (params[key] instanceof Array) {
                  sanitizedParams[key] = params[key];
                } else {
                  sanitizedParams[key] = [params[key]];
                }
              }
          } else {
            sanitizedParams[key] = params[key];
          }
          // passing the RCDS param along to the object
        }
      }
      // console.log("sanitizedParams: ", sanitizedParams)
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return sanitizedParams;
  };
  //reduce the array to on object keyed from "keyField"
  var arrayToObject = function arrayToObject(array, keyField) {
    return array.reduce(function (obj, item) {
      obj[item[keyField]] = item;
      return obj;
    }, {});
  };

  //reduce the array to on object keyed from "keyField" and set it as an array of objects keyed from search term if needed
  var searchTermKeyed = function searchTermKeyed(array, keyField) {
    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    var reduceArray = array.reduce(function (obj, item) {
      obj[item[keyField]] = item;
      return obj;
    }, {});
    var queryString = JSON.stringify(query);
    //return the keyed object with the search term as the object key
    return {
      queryString: [queryString],
      data: reduceArray
    };
  };
  //store child ids in array so they can be referenced by ID if needed
  var childIdsArray = function childIdsArray(array, keyField) {
    var childIdsList = array.map(function (item, index, childItems) {
      return item[keyField];
    });
    return childIdsList;
  };

  //
  var helpers = { sanitizeParams: sanitizeParams, getParams: getParams, geoLocations: geoLocations, arrayToObject: arrayToObject, searchTermKeyed: searchTermKeyed, childIdsArray: childIdsArray };
  exports.sanitizeParams = sanitizeParams;
  exports.getParams = getParams;
  exports.geoLocations = geoLocations;
  exports.arrayToObject = arrayToObject;
  exports.searchTermKeyed = searchTermKeyed;
  exports.childIdsArray = childIdsArray;
  exports.default = helpers;
});